import PaymentsList from './PaymentsList';

export default PaymentsList;
